module.exports = __webpack_public_path__ + "videos/ipad-hero_cn.78198f8.mp4";